import api from './api';

class ReportService {
  async getFinancialReport(params = {}) {
    const response = await api.get('/reports/financial', { params });
    return response.data;
  }

  async getPortfolioReport(params = {}) {
    const response = await api.get('/reports/portfolio', { params });
    return response.data;
  }

  async getAgencyPerformance(params = {}) {
    const response = await api.get('/reports/agency-performance', { params });
    return response.data;
  }

  async getLoanProductReport(params = {}) {
    const response = await api.get('/reports/loan-products', { params });
    return response.data;
  }

  async getClientReport(params = {}) {
    const response = await api.get('/reports/clients', { params });
    return response.data;
  }

  async getDailyCollectionReport(date) {
    const response = await api.get('/reports/daily-collection', { params: { date } });
    return response.data;
  }

  async exportReport(type, format = 'pdf', params = {}) {
    const response = await api.get(`/reports/export/${type}`, {
      params: { format, ...params },
      responseType: 'blob'
    });
    return response.data;
  }
}

export default new ReportService();